import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, loading, hasPermission, user } = useAuth();

  // Debug logging
  React.useEffect(() => { 
    if (requiredPermission) { 
    }
  }, [isAuthenticated, loading, requiredPermission, user, hasPermission]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    console.log(`❌ Permission denied for "${requiredPermission}"`);
    return <Navigate to="/unauthorized" replace />;
  }

  console.log(`✅ Permission granted for "${requiredPermission}"`);
  return children;
};

export default ProtectedRoute;